<script>

import moment from "moment";

export default {
    name: "TimeOnlyPicker",
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        isRequired: {
            type: Boolean,
            required: true
        },
        value: {
            required: true,
            default() {
                return moment();
            }
        },
        format: {
            type: String,
            default() {
                return "YYYY/MM/DD"
            }
        },
        classList: {
            type: Array,
            default() {
                let list = []

                if (this.isRequired)
                    list.push("required")

                return list
            }
        }
    },
    data() {
        return {
            time: this.value,
            moment: moment(this.value, this.format),
            classes: [
                "date-input-group-new-design",
                "text_input",
                "form-control",
                ...this.classList
            ]
        }
    },
    mounted() {
        $(this.$refs.timepicker).datetimepicker({
            format: this.format
        }).on('dp.change', (e) => {
            this.time = e.date.format(this.format);
            if (e.date && typeof e.date === "object") {
                // this.moment = moment(e.date);
            }
        });
    },
    watch: {
        value(value) {
            this.time = value
        },
        time(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<template>
    <div>
        <div ref="timepicker" class="input-group clockpicker new-design-parent">
            <input  type="text" v-model="time" :class="classes.join(' ')" :id="id" :name="name"
                   placeholder="Time"/>
            <span class="input-group-addon input-group-addon-new-design">
                <span class="glyphicon glyphicon-time"></span>
            </span>
        </div>
        <label :for="id" generated="true" class="error"></label>
    </div>
</template>

<style scoped>

</style>